import React, { useState, useEffect } from "react";
import amaxLogo from "../../images/amaxLogoWhite.png";
import arrowNext from "../../images/arrowNext.svg";
import { Link, useNavigate } from "react-router-dom";
import API_URL from "../../api/API";

const AthleteStep6 = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const [pr_100m, setPR100m] = useState("");
  const [pr_200m, setPR200m] = useState("");
  const [pr_400m, setPR400m] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!pr_100m || !pr_200m || !pr_400m) {
      setError("Please enter the distance times.");
      return;
    }

    setError(null);
    setMsg(null);
    setLoading(true);

    // Fetch all saved data from session
    const firstname = sessionStorage.getItem("firstname");
    const lastname = sessionStorage.getItem("lastname");
    const phonenumber = sessionStorage.getItem("phonenumber");
    const email = sessionStorage.getItem("email");
    const password = sessionStorage.getItem("password");
    const training_preference = sessionStorage.getItem("training_preference");
    const sport = sessionStorage.getItem("sport");
    const sport_other = sessionStorage.getItem("otherSportValue") || null;
    const city = sessionStorage.getItem("city");
    const state = sessionStorage.getItem("state");
    const dob = sessionStorage.getItem("dob");
    const gender = sessionStorage.getItem("gender");
    const height_feet = sessionStorage.getItem("heightFeet");
    const height_inches = sessionStorage.getItem("heightInches");
    const weight = sessionStorage.getItem("weight");

    try {
      const response = await fetch(API_URL.POST_CREATE_ATHLETE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstname,
          lastname,
          phonenumber,
          email,
          password,
          training_preference,
          sport,
          sport_other,
          city,
          state,
          dob,
          gender,
          height_feet,
          height_inches,
          weight,
          pr_100m,
          pr_200m,
          pr_400m,
        }),
      });

      const json = await response.json();
      setLoading(false);

      if (response.ok) {
        setMsg(json.message || "Athlete registered successfully!");
        sessionStorage.clear();
        setPR100m("");
        setPR200m("");
        setPR400m("");
      } else {
        setError(json.error || "An error occurred. Please try again.");
      }
    } catch (err) {
      setLoading(false);
      setError("Failed to connect to the server. Please try again.");
    }
  };

  return (
    <div className={`p-[20px] bg-white h-dvh overflow-hidden`}>
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-4 overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>
        <div className="flex flex-col gap-10 w-full">
          <div>
            <div className="flex flex-col justify-center gap-4">
              <h1 className="text-black text-3xl xs:text-4xl leading-tight font-light uppercase">
                SET YOUR <br />
                <span className="text-4xl xs:text-5xl leading-tight font-bold">
                  goals
                </span>
              </h1>
              <div className="rounded-2xl flex flex-row gap-4">
                <div className="w-1/2 border border-grayish rounded-2xl p-5 flex flex-col justify-between">
                  <label className="text-sm text-black leading-none mb-2">
                    100m PR
                  </label>
                  <input
                    type="text"
                    className="text-black text-base xs:text-lg font-light !leading-none placeholder:text-grayish placeholder:uppercase w-full"
                    value={pr_100m}
                    onChange={(e) => setPR100m(e.target.value)}
                  />
                </div>
                <div className="w-1/2 border border-grayish rounded-2xl p-5 flex flex-col justify-between">
                  <label className="text-sm text-black leading-none mb-2">
                    200m PR
                  </label>
                  <input
                    type="text"
                    value={pr_200m}
                    onChange={(e) => setPR200m(e.target.value)}
                    className="text-black text-base xs:text-lg font-light !leading-none placeholder:text-grayish placeholder:uppercase w-full"
                  />
                </div>
              </div>
              <div className="border border-grayish rounded-2xl p-5 flex flex-col justify-between gap-[22px]">
                <label className="text-sm text-black leading-none">
                  400m PR
                </label>
                <input
                  type="text"
                  value={pr_400m}
                  onChange={(e) => setPR400m(e.target.value)}
                  className="text-black text-base xs:text-lg font-light !leading-none placeholder:text-grayish placeholder:uppercase w-full"
                />
              </div>
            </div>
            {loading && (
              <p className="text-yellow-500 text-sm mt-2">
                Processing request please wait...
              </p>
            )}

            {/* Display Success Message */}
            {msg && (
  <div className="mt-5 p-5 bg-green-50 border border-green-200 rounded-2xl text-center">
    <p className="text-2xl font-bold text-black mb-2">🎉 Congratulations!</p>
    <p className="text-green-700 text-sm font-light leading-relaxed">
      Your Amax Speed account is ready. Check your inbox (or spam), verify your email, then sign in.
    </p>
    <Link
      to="/athlete/login"
      className="inline-block mt-3 text-sm xs:text-base font-medium text-black underline hover:text-black/70 transition-all duration-300"
    >
      Go to Login
    </Link>
  </div>
)}

            {/* Display Error Message */}
            {error && <p className="text-red-500 text-sm mt-5">{error}</p>}
          </div>
          <div className="flex flex-row justify-between items-center">
            <p className="text-black text-[30px] font-light uppercase leading-none">
              get <br />
              <span className="font-bold">faster.</span>
            </p>

            {/* Display Loading Indicator */}

            <button
              type="button"
              onClick={handleSubmit}
              className="bg-black size-12 xs:size-14 rounded-full flex justify-center items-center hover:bg-black/70 transition-all duration-300 ml-auto mt-[10px]"
            >
              <img
                src={arrowNext}
                alt="arrow"
                className="object-contain invert max-w-5 xs:max-w-6 "
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AthleteStep6;
